import { render, staticRenderFns } from "./VModal.vue?vue&type=template&id=07aa3522&scoped=true"
import script from "./VModal.vue?vue&type=script&lang=ts"
export * from "./VModal.vue?vue&type=script&lang=ts"
import style0 from "./VModal.vue?vue&type=style&index=0&id=07aa3522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aa3522",
  null
  
)

export default component.exports